// image-processing-loader
var previousRequest = require("!!../../../../../node_modules/fox-file-loader/index.js!../../../../../node_modules/file-loader/index.js?name=[path][name].[ext]!./slideshow_stop.png");
var dir = previousRequest.replace("slideshow_stop.png", "")
module.exports = require("!../../../../../node_modules/fox-image-optimize-plugin/router.js")({
	dir: dir,
	base: "slideshow_stop.png",
	name: "slideshow_stop",
	ext: ".png",
	query: ""
}, previousRequest);


//////////////////
// WEBPACK FOOTER
// ./images/slideshow_stop.png
// module id = 1117
// module chunks = 4